import { ILocation } from '../../api/locations';
import { FOfferType, isSuburban } from '../../utils/category';
import { locationHasHighways } from '../../utils/geo';

export function isHighwaysEnabled(offerType: FOfferType, location: ILocation | 'moscow_mo' | 'spb_lo'): boolean {
  return isSuburban(offerType) && locationHasHighways(location);
}
